import { getUsers } from '@/api/requests';
import router from '../../router';

const state = {
  selectedChallenge: {},
  selectedUser: {},
  viewChallengeDetails: false,
  awardingChallenge: false,
  users: [],
};

const mutations = {
  setSelectedChallenge(state, challenge) {
    state.selectedChallenge = challenge;
  },

  setSelectedUser(state, user) {
    state.users = [];
    state.selectedUser = user;
  },

  viewChallengeDetailsClicked(state) {
    state.viewChallengeDetails = true;
  },

  awardChallengeClicked(state) {
    state.awardingChallenge = true;
  },

  clearSelectedChallenge(state) {
    state.selectedChallenge = {};
    state.selectedUser = {};
    state.users = [];
    state.viewChallengeDetails = false;
    state.awardingChallenge = false;
  },

  saveUsers(state, users) {
    state.users = users;
  },
};

const actions = {
  challengeClicked(context, challenge) {
    context.commit('setSelectedChallenge', challenge);
    context.commit('viewChallengeDetailsClicked');
  },

  awardChallengeClicked(context, challenge) {
    context.commit('setSelectedChallenge', challenge);
    context.commit('awardChallengeClicked');
  },

  challengeDetailsClosed(context) {
    context.commit('clearSelectedChallenge');
  },

  searchUsers(context, search) {
    let payload = { search };
    getUsers(payload).then((response) => {
      context.commit('saveUsers', response.data.data);
    });
  },

  selectUser(context, user) {
    context.commit('setSelectedUser', user);
  }
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};